var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('formCommon',{ref:"formCommon",attrs:{"form-array":_vm.formArray,"rules":_vm.rules},on:{"getData":_vm.getData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }